"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('adyen/adyen/commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('../../../../../../../../../app_adyen_SFRA/cartridge/config/store');
var helpers = require('../../../checkout/helpers');
var _require2 = require('../../../../../../../../../app_adyen_SFRA/cartridge/config/constants'),
  PAYPAL = _require2.PAYPAL;
var _require3 = require('adyen/adyen/express/initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var _require4 = require('adyen/adyen/commons'),
  createTemporaryBasket = _require4.createTemporaryBasket;
var Paypal = /*#__PURE__*/function () {
  function Paypal(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
    _classCallCheck(this, Paypal);
    var _window = window,
      paypalReviewPageEnabled = _window.paypalReviewPageEnabled,
      returnURL = _window.returnURL,
      basketAmount = _window.basketAmount,
      makeExpressPaymentsCall = _window.makeExpressPaymentsCall,
      saveShopperData = _window.saveShopperData,
      makeExpressPaymentDetailsCall = _window.makeExpressPaymentDetailsCall,
      showConfirmationAction = _window.showConfirmationAction,
      shippingMethodsUrl = _window.shippingMethodsUrl,
      selectShippingMethodUrl = _window.selectShippingMethodUrl,
      saveExpressPaymentDataUrl = _window.saveExpressPaymentDataUrl;
    this.store = store;
    this.helpers = helpers;
    this.returnUrl = returnURL;
    this.amount = initialAmount || JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.isExpressPdp = isExpressPdp;
    this.blockPayPalCreditButton = true;
    this.blockPayPalPayLaterButton = true;
    this.blockPayPalVenmoButton = true;
    this.userAction = paypalReviewPageEnabled ? 'continue' : null;
    this.makeExpressPaymentsCallUrl = makeExpressPaymentsCall;
    this.saveShopperDataUrl = saveShopperData;
    this.makeExpressPaymentDetailsCallUrl = makeExpressPaymentDetailsCall;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.saveExpressPaymentDataUrl = saveExpressPaymentDataUrl;
    this.applicationInfo = applicationInfo;
    this.translations = adyenTranslations;
    this.config = config;
  }
  return _createClass(Paypal, [{
    key: "callPaymentFromComponent",
    value: function () {
      var _callPaymentFromComponent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(state, component) {
        var tempBasketResponse, response, action;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              $.spinner().start();
              this.helpers.paypalExpressAnalytics();
              // Create temporary basket for PDP express checkout
              if (!this.isExpressPdp) {
                _context.next = 9;
                break;
              }
              _context.next = 5;
              return createTemporaryBasket();
            case 5:
              tempBasketResponse = _context.sent;
              if (tempBasketResponse !== null && tempBasketResponse !== void 0 && tempBasketResponse.temporaryBasketCreated) {
                _context.next = 9;
                break;
              }
              component.handleError(new Error('Failed to create temporary basket'));
              return _context.abrupt("return");
            case 9:
              _context.next = 11;
              return httpClient({
                method: 'POST',
                url: this.makeExpressPaymentsCallUrl,
                data: {
                  csrf_token: $('#adyen-token').val(),
                  data: JSON.stringify(_objectSpread(_objectSpread({}, state.data), {}, {
                    isExpressPdp: this.isExpressPdp
                  }))
                }
              });
            case 11:
              response = _context.sent;
              action = response.fullResponse ? response.fullResponse.action : response.action? response.action : null;
              if (action) {
                component.handleAction(action);
              } else {
                component.handleError();
              }
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              component.handleError(_context.t0);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 16]]);
      }));
      function callPaymentFromComponent(_x, _x2) {
        return _callPaymentFromComponent.apply(this, arguments);
      }
      return callPaymentFromComponent;
    }()
  }, {
    key: "onAuthorized",
    value: function () {
      var _onAuthorized = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data, actions) {
        var _payer$phone, _payer$phone$phone_nu, _payer$name, _payer$name2, _data$authorizedEvent, payer, billingAddress, deliveryAddress, shopperDetails;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _data$authorizedEvent = data.authorizedEvent.payer, payer = _data$authorizedEvent === void 0 ? {} : _data$authorizedEvent, billingAddress = data.billingAddress, deliveryAddress = data.deliveryAddress;
              let originalDeliveryAddress = data.authorizedEvent.purchase_units[0].shipping.address;
              let originalBillingAddress = data.authorizedEvent.payer.address;
              deliveryAddress.address1 = originalDeliveryAddress.address_line_1;
              deliveryAddress.address2 = originalDeliveryAddress.address_line_2;
              billingAddress.address1 = originalBillingAddress.address_line_1;
              billingAddress.address2 = originalBillingAddress.address_line_2;
              shopperDetails = {
                shopperEmail: payer.email_address,
                telephoneNumber: (_payer$phone = payer.phone) === null || _payer$phone === void 0 ? void 0 : (_payer$phone$phone_nu = _payer$phone.phone_number) === null || _payer$phone$phone_nu === void 0 ? void 0 : _payer$phone$phone_nu.national_number,
                shopperName: {
                  firstName: (_payer$name = payer.name) === null || _payer$name === void 0 ? void 0 : _payer$name.given_name,
                  lastName: (_payer$name2 = payer.name) === null || _payer$name2 === void 0 ? void 0 : _payer$name2.surname
                },
                shippingAddress: deliveryAddress,
                billingAddress: billingAddress,
                isExpressPdp: this.isExpressPdp
              };
              _context2.next = 5;
              return httpClient({
                method: 'POST',
                url: this.saveShopperDataUrl,
                data: {
                  data: JSON.stringify(shopperDetails)
                }
              });
            case 5:
              actions.resolve();
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              $.spinner().stop();
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function onAuthorized(_x3, _x4) {
        return _onAuthorized.apply(this, arguments);
      }
      return onAuthorized;
    }()
  }, {
    key: "makeExpressPaymentDetailsCall",
    value: function () {
      var _makeExpressPaymentDetailsCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return httpClient({
                method: 'POST',
                url: this.makeExpressPaymentDetailsCallUrl,
                data: {
                  data: JSON.stringify({
                    data: data,
                    isExpressPdp: this.isExpressPdp
                  })
                }
              });
            case 3:
              response = _context3.sent;
              this.helpers.createShowConfirmationForm(this.showConfirmationAction);
              this.helpers.setOrderFormData(response);
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              $.spinner().stop();
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 8]]);
      }));
      function makeExpressPaymentDetailsCall(_x5) {
        return _makeExpressPaymentDetailsCall.apply(this, arguments);
      }
      return makeExpressPaymentDetailsCall;
    }()
  }, {
    key: "onShippingAddressChange",
    value: function () {
      var _onShippingAddressChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data, actions, component) {
        var shippingAddress, currentPaymentData, requestBody, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              shippingAddress = data.shippingAddress;
              currentPaymentData = component.paymentData;
              if (shippingAddress) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", actions.reject());
            case 5:
              requestBody = {
                paymentMethodType: PAYPAL,
                currentPaymentData: currentPaymentData,
                isExpressPdp: this.isExpressPdp,
                address: {
                  city: shippingAddress.city,
                  country: shippingAddress.country,
                  countryCode: shippingAddress.countryCode,
                  stateCode: shippingAddress.state,
                  postalCode: shippingAddress.postalCode
                }
              };
              _context4.next = 8;
              return httpClient({
                method: 'POST',
                url: this.shippingMethodsUrl,
                data: {
                  data: JSON.stringify(requestBody)
                }
              });
            case 8:
              response = _context4.sent;
              Paypal.updateComponent(response, component);
              return _context4.abrupt("return", null);
            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", actions.reject(data.errors.ADDRESS_ERROR));
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 13]]);
      }));
      function onShippingAddressChange(_x6, _x7, _x8) {
        return _onShippingAddressChange.apply(this, arguments);
      }
      return onShippingAddressChange;
    }()
  }, {
    key: "onShippingOptionsChange",
    value: function () {
      var _onShippingOptionsChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(data, actions, component) {
        var selectedShippingOption, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              selectedShippingOption = data.selectedShippingOption;
              if (selectedShippingOption) {
                _context5.next = 4;
                break;
              }
              return _context5.abrupt("return", actions.reject());
            case 4:
              _context5.next = 6;
              return httpClient({
                method: 'POST',
                url: this.selectShippingMethodUrl,
                data: {
                  data: JSON.stringify({
                    paymentMethodType: PAYPAL,
                    currentPaymentData: component.paymentData,
                    methodID: selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.id,
                    isExpressPdp: this.isExpressPdp
                  })
                }
              });
            case 6:
              response = _context5.sent;
              Paypal.updateComponent(response, component);
              return _context5.abrupt("return", null);
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", actions.reject(data.errors.METHOD_UNAVAILABLE));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 11]]);
      }));
      function onShippingOptionsChange(_x9, _x0, _x1) {
        return _onShippingOptionsChange.apply(this, arguments);
      }
      return onShippingOptionsChange;
    }()
  }, {
    key: "onAdditionalDetails",
    value: function () {
      var _onAdditionalDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(state, component) {
        var response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              if (!this.userAction) {
                _context6.next = 8;
                break;
              }
              _context6.next = 4;
              return httpClient({
                method: 'POST',
                url: this.saveExpressPaymentDataUrl,
                data: {
                  data: JSON.stringify(_objectSpread(_objectSpread({}, state.data), {}, {
                    isExpressPdp: this.isExpressPdp
                  }))
                }
              });
            case 4:
              response = _context6.sent;
              if (response.success && response.redirectUrl) {
                var redirect = $('<form>').appendTo(document.body).attr({
                  method: 'POST',
                  action: response.redirectUrl
                });
                $('<input>').appendTo(redirect).attr({
                  name: 'data',
                  value: JSON.stringify(state.data)
                });
                redirect.submit();
              }
              _context6.next = 12;
              break;
            case 8:
              _context6.next = 10;
              return this.makeExpressPaymentDetailsCall(state.data);
            case 10:
              document.querySelector('#additionalDetailsHidden').value = JSON.stringify(state.data);
              document.querySelector('#showConfirmationForm').submit();
            case 12:
              _context6.next = 18;
              break;
            case 14:
              _context6.prev = 14;
              _context6.t0 = _context6["catch"](0);
              component.handleError(_context6.t0);
              $.spinner().stop();
            case 18:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 14]]);
      }));
      function onAdditionalDetails(_x10, _x11) {
        return _onAdditionalDetails.apply(this, arguments);
      }
      return onAdditionalDetails;
    }()
  }, {
    key: "getConfig",
    value: function getConfig() {
      return _objectSpread(_objectSpread({
        configuration: this.config,
        showPayButton: this.showPayButton,
        returnUrl: this.returnUrl,
        amount: this.amount,
        isExpress: this.isExpress,
        // Added below lines to block paypal paylater and venmo payment methods
        blockPayPalCreditButton: true,
        blockPayPalPayLaterButton: true,
        blockPayPalVenmoButton: true,
      }, this.userAction ? {
        userAction: this.userAction
      } : {}), {}, {
        onSubmit: this.callPaymentFromComponent.bind(this),
        onError: Paypal.onError,
        onAuthorized: this.onAuthorized.bind(this),
        onAdditionalDetails: this.onAdditionalDetails.bind(this),
        onShippingAddressChange: this.onShippingAddressChange.bind(this),
        onShippingOptionsChange: this.onShippingOptionsChange.bind(this),
        blockPayPalCreditButton: true,
        blockPayPalPayLaterButton: true
      });
    }
  }, {
    key: "getComponent",
    value: function () {
      var _getComponent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var checkout, paypalConfig;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return initializeCheckout(this.applicationInfo, this.translations);
            case 2:
              checkout = _context7.sent;
              paypalConfig = this.getConfig();
              return _context7.abrupt("return", window.AdyenWeb.createComponent(PAYPAL, checkout, paypalConfig));
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getComponent() {
        return _getComponent.apply(this, arguments);
      }
      return getComponent;
    }()
  }], [{
    key: "updateComponent",
    value: function updateComponent(response, component) {
      if (response) {
        var paymentData = response.paymentData,
          status = response.status,
          _response$errorMessag = response.errorMessage,
          errorMessage = _response$errorMessag === void 0 ? '' : _response$errorMessag;
        if (!paymentData || status !== 'success') {
          throw new Error(errorMessage);
        }
        // Update the Component paymentData value with the new one.
        component.updatePaymentData(paymentData);
      } else {
        var _response$errorMessag2 = response.errorMessage,
          _errorMessage = _response$errorMessag2 === void 0 ? '' : _response$errorMessag2;
        throw new Error(_errorMessage);
      }
      return false;
    }
  }, {
    key: "onError",
    value: function onError() {
      $.spinner().stop();
    }
  }]);
}();
module.exports = Paypal;